// Event Bus for cross-component communication
class EventBus {
  private events: { [key: string]: Function[] } = {}

  on(event: string, callback: Function) {
    if (!this.events[event]) {
      this.events[event] = []
    }
    this.events[event].push(callback)
  }

  off(event: string, callback: Function) {
    if (this.events[event]) {
      this.events[event] = this.events[event].filter(cb => cb !== callback)
    }
  }

  emit(event: string, data?: any) {
    if (this.events[event]) {
      this.events[event].forEach(callback => callback(data))
    }
    
    // Also emit as window event for backward compatibility
    window.dispatchEvent(new CustomEvent(event, { detail: data }))
  }
}

export const eventBus = new EventBus()